import { useEffect, useRef } from 'react';

export const useOnMount = (callback) => {
  const didMountRef = useRef(false);

  useEffect(() => {
    if (callback && !didMountRef.current) {
      didMountRef.current = true;
      callback();
    }
  }, [callback]);
};
